import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { ProdutividadeFiltroComponent } from './produtividade-filtro/produtividade-filtro.component';
import { ProdutividadeListaComponent } from './produtividade-lista/produtividade-lista.component';
import { ProdutividadeService } from './produtividade-service/produtividade.service';
import { ProdutividadeComponent } from './produtividade.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    NgbModule,
    TableModule,
    ButtonModule,
    DialogModule,
    CalendarModule,
    TooltipModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    ProdutividadeComponent
  ],
  declarations: [
    ProdutividadeComponent,
    ProdutividadeListaComponent,
    ProdutividadeFiltroComponent
  ],
  providers: [
    ProdutividadeService,
    DecimalPipe
  ]
})
export class ProdutividadeModule { }
